//
//
//
//
//
//
//
//
//
//
//
//

import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';

export default {
  components: {
    Step1,
    Step2,
    Step3
  },
  created() {
    let now_step = this.$route.query.step;
    if (now_step === undefined) {
      this.$http.get(this.tianYiWebUrl +'/wechat/uc/getSellerRequestStep').then((r)=>{
        if (r.data.code === 200) {
          let step = r.data.data.step;
          console.log(step)
          this.$router.push('/uc/seller-request?step=' + step)
        }
      })
    }
  },
  methods: {}
}



// WEBPACK FOOTER //
// ./src/components/sellerRequest/SellerRequest.vue